export default __webpack_public_path__ + "static/media/honey-noggles.72b85515.svg";